(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CategoryIbqDetailController', CategoryIbqDetailController);

    CategoryIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Category', 'MusicalPiece'];

    function CategoryIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Category, MusicalPiece) {
        var vm = this;

        vm.category = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:categoryUpdate', function(event, result) {
            vm.category = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
